module.exports = __webpack_public_path__ + "static/media/Montserrat-Bold.9c71d42b.otf";